// Function to generate random colors that are visible on white background
const generateRandomColor = () => {
  const transparency = 0.3; // Adjust the transparency value as needed
  const color = '#' + Math.floor(Math.random() * 16777215).toString(16);
  const rgb = parseInt(color.substring(1), 16);
  const alpha = Math.round(255 * transparency);
  const rgbaColor = `rgba(${(rgb >> 16) & 255}, ${(rgb >> 8) & 255}, ${rgb & 255}, ${alpha})`;
  return rgbaColor;
};


// Retrieve or generate color based on the colorBy value
export const getColor = (keyName, colorBy) => {
  const colorMap = JSON.parse(localStorage.getItem(`color_map`) || "{}");
  // console.log(colorMap);
  // console.log(colorBy, colorMap[colorBy]);
  if (colorMap[colorBy]) return colorMap[colorBy];
  else {
    colorMap[colorBy] = generateRandomColor();
    localStorage.setItem(`color_map`, JSON.stringify(colorMap));
    return colorMap[colorBy];
  }
};